import {
  FETCH_FEATURED_MATERIAL_REQUESTED,
  FETCH_FEATURED_MATERIAL_SUCCESSFUL,
  FETCH_FEATURED_MATERIAL_FAILED,
  FETCH_TOP_COURSES_REQUESTED,
  FETCH_TOP_COURSES_SUCCESSFUL,
  FETCH_TOP_COURSES_FAILED,
} from "./action-types"

export const fetchFeaturedMaterial = (data) => {
  return {
    types: [
      FETCH_FEATURED_MATERIAL_REQUESTED,
      FETCH_FEATURED_MATERIAL_SUCCESSFUL,
      FETCH_FEATURED_MATERIAL_FAILED,
    ],
    payload: {
      request: {
        method: "GET",
        url: `/schools/${data}/featured_material/`,
        auth: false,
      },
    },
  }
}

export const fetchTopCourses = (data) => {
  return {
    types: [
      FETCH_TOP_COURSES_REQUESTED,
      FETCH_TOP_COURSES_SUCCESSFUL,
      FETCH_TOP_COURSES_FAILED,
    ],
    payload: {
      request: {
        method: "GET",
        url: `/schools/${data}/top_courses/`,
        auth: false,
      },
    },
  }
}
